import { useNavigate, useParams } from "react-router-dom";
import ProjectAdd from "../../components/Projects/ProjectAdd";

const ProjectAddWrapper = () => {
  const navigate = useNavigate();

  const { accountId } = useParams<{accountId:string}>();

  if (!accountId) {
    navigate("/projects/list");
    return null;
  }

  return (
    <ProjectAdd
      accountId={Number(accountId)}
      onCancelAction={() => navigate(-1)}
    />
  );
};

export default ProjectAddWrapper;
